import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { QidModelOptionCreate } from "server/models"
import { StateType } from "client/utils"
import {
    StoreType,
    QidModelOptionValidation,
    SaveQidModelOption,
    setQidModelEditOption,
    setQidModelReloadList,
    setQidDatapointReloadList,
} from "client/store"
import {
    Button,
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmBottom,
    FormGroup,
    Input,
    Feedback,
    SpinnerIcon,
} from "client/components"

const EditOption = () => {
    const option = useSelector((state: StoreType) => state.qidModel.editOption)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [name, setName] = useState(option ? option.name : "")
    const [validation, setValidation] = useState<QidModelOptionValidation>(null)

    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        setName(option ? option.name : "")
        setValidation(null)
    }, [option])

    const onCancel = () => {
        dispatch(setQidModelEditOption(null))
    }

    const onSave = () => {
        setSaveState(PENDING)

        const newOptionData: QidModelOptionCreate = {
            safetyFunctionId: option.safetyFunctionId,
            name,
        }

        const updated = option && option.id && (
            option.name !== name
        )

        SaveQidModelOption(
            option && option.id,
            newOptionData,
            updated,
            lang,
        ).then((res) => {
            setValidation(res.validation)
            setSaveState(IDLE)
            if (res.validation) return

            dispatch(setQidModelReloadList(false))
            dispatch(setQidDatapointReloadList(false))
            setTimeout(() => {
                dispatch(setQidModelReloadList(true))
                dispatch(setQidDatapointReloadList(true))
            }, 0)

            dispatch(setQidModelEditOption(null))
        })
    }

    return (
        <ConfirmWrapper show={option !== null} onClose={onCancel}>
            <Confirm>
                <ConfirmTitle>{option && option.id ? `${lang.editOption} # ${option.id}` : lang.addOption}</ConfirmTitle>
                <FormGroup>
                    <Input type="text" value={name} onChange={(e) => setName(e.target.value)} />
                    <Feedback>{validation && validation.name}</Feedback>
                </FormGroup>

                <ConfirmBottom>
                    <Button variant="success" row onClick={onSave}>
                        {saveState === PENDING ? <SpinnerIcon /> : lang.save}
                    </Button>
                    <Button row onClick={onCancel}>
                        {lang.cancel}
                    </Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default EditOption
